/* Odkaz „Co je nového“ v levé liště + tečka, dokud poradce nejnovější
 * vydání neviděl (24. 10. 2026). Logika v lib/novinky.js, data v data/novinky.js.
 *
 * Lišta je tmavá ve všech motivech → barvy z rodiny --sidebar-* (viz hlavička
 * LeftSidebar.js). Tečka = --sidebar-marker, stejný „pozor tady“ jako značka
 * aktivní sekce.
 */
import { useSyncExternalStore } from "react";
import { Megaphone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { odebirejZemi, zemeTenanta } from "@/lib/tenantMena";
import { TEXTY_NOVINEK, jazykNovinek, useNovinkyNeprectene } from "@/lib/novinky";

export default function OdkazNovinky({ expanded, active = false, onClick }) {
  const { lang } = useLanguage();
  const zeme = useSyncExternalStore(odebirejZemi, zemeTenanta, zemeTenanta);
  const T = TEXTY_NOVINEK[jazykNovinek(lang, zeme)];
  const neprectene = useNovinkyNeprectene();
  const popisek = neprectene ? T.odkazNeprectene : T.nadpis;

  return (
    <button
      type="button"
      onClick={() => onClick("/novinky")}
      className="relative mb-1 flex w-full items-center px-4 py-2 text-drobny transition-colors hover:bg-[var(--sidebar-hover-bg)]"
      style={{
        background: active ? "var(--sidebar-active-bg)" : undefined,
        color: active ? "var(--sidebar-active-ink)" : "var(--sidebar-ink)",
      }}
      data-testid="sidebar-novinky"
      data-neprectene={neprectene ? "1" : "0"}
      title={popisek}
      aria-label={popisek}
      aria-current={active ? "page" : undefined}
    >
      <span className="relative flex-shrink-0">
        <Megaphone size={15} aria-hidden />
        {neprectene && (
          <span
            aria-hidden
            data-testid="sidebar-novinky-tecka"
            className="absolute -right-1 -top-1 h-2 w-2 rounded-full"
            style={{ background: "var(--sidebar-marker)", boxShadow: "0 0 6px var(--sidebar-marker-glow)" }}
          />
        )}
      </span>
      {expanded && <span className="ml-3 flex-1 truncate text-left font-medium">{T.nadpis}</span>}
    </button>
  );
}
